/**
 * L'Agenda sur sa page, ou dans l'angle Agenda d'une feuille (chantier angles-du-projet, ticket
 * 03). C'est le même écran (`Agenda.tsx`, `Chronologie.tsx`, `Calendrier.tsx`), jamais une
 * copie : dans l'angle, la portée est la bulle ouverte, filtrée par le serveur, et ce qui ne
 * parle que de la page s'efface.
 *
 * Dans l'angle : ni le titre, ni les pastilles des projets (la portée est la bulle ouverte), ni
 * « Préparer ma journée » (une journée couvre tous les projets : un jour ne se clique pas), ni la
 * page de présentation (un mot à la place) ; la vue et le mois vivent dans l'écran, pas dans
 * l'adresse, qui reste celle de la feuille. Le choix Chronologie ou Calendrier et l'export restent.
 */
export interface PartiesDeLAgenda {
  /** « Agenda », en tête. */
  titre: boolean;
  /** Les pastilles des projets. */
  filtres: boolean;
  /** Un jour qui se clique ouvre « Préparer ma journée ». */
  preparer: boolean;
  /** La vue, le mois et le jour ouvert dans l'adresse (`/agenda?vue=…`). */
  adresse: boolean;
  /** La page de présentation de l'Agenda vide. */
  presentation: boolean;
}

export function partiesDeLAgenda({ dansUnAngle }: { dansUnAngle: boolean }): PartiesDeLAgenda {
  const surLaPage = !dansUnAngle;
  return { titre: surLaPage, filtres: surLaPage, preparer: surLaPage, adresse: surLaPage, presentation: surLaPage };
}
